import { TranslationService } from '@core/translation/translation.service';

export enum InvoiceTypes {
    Invoice = 'invoice', // Rechnung
    CancellationInvoice = 'cancellationInvoice', // Stornorechnung
    Crediting = 'crediting', // Gutschrift
    CancellationCrediting = 'cancellationCrediting', // Stornogutschrift
}

export enum ReceiptTypes {
    PayIn = 'payIn',
    PayOut = 'payOut',
    Receipt = 'receipt',
    ReceiptError = 'error',
    CancellationReceipt = 'cancellationReceipt'
}

export enum QuoteDocumentType {
    Quote = 'quote',
}

export enum InvoiceOrReceiptType {
    Invoice = 'invoice', // Rechnung
    InvoiceCollection = 'invoice_collection', // Sammelrechnung
    CancellationInvoice = 'cancellationInvoice', // Stornorechnung
    Crediting = 'crediting', // Gutschrift
    CancellationCrediting = 'cancellationCrediting', // Stornogutschrift
    Receipt = 'receipt',
    CancellationReceipt = 'cancellationReceipt',
    ReceiptError = 'error',
    Quote = 'quote',
}

export const financialRecordTypeTranslationsDe: { [key in InvoiceTypes | ReceiptTypes | QuoteDocumentType]: string } = {
    [InvoiceTypes.Invoice]: TranslationService.translate('accounting.financialDocuments.invoice'),
    [InvoiceTypes.CancellationInvoice]: TranslationService.translate('accounting.financialDocuments.cancellationInvoice'),
    [InvoiceTypes.Crediting]: TranslationService.translate('accounting.financialDocuments.crediting'),
    [InvoiceTypes.CancellationCrediting]: TranslationService.translate('accounting.financialDocuments.cancellationCrediting'),

    [ReceiptTypes.PayIn]: TranslationService.translate('accounting.financialDocuments.payIn'),
    [ReceiptTypes.PayOut]: TranslationService.translate('accounting.financialDocuments.payOut'),
    [ReceiptTypes.Receipt]: TranslationService.translate('accounting.financialDocuments.receipt'),
    [ReceiptTypes.ReceiptError]: TranslationService.translate('accounting.financialDocuments.receiptError'),
    [ReceiptTypes.CancellationReceipt]: TranslationService.translate('accounting.financialDocuments.cancellationReceipt'),

    [QuoteDocumentType.Quote]: TranslationService.translate('accounting.financialDocuments.quote'),
};
